import React from 'react';

interface SchemaMarkupProps {
  type: 'organization' | 'localBusiness' | 'article';
  data?: any;
}

export const SchemaMarkup: React.FC<SchemaMarkupProps> = ({ type, data }) => {
  const getSchemaData = () => {
    switch (type) {
      case 'organization':
        return {
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "RS International Services - Residencia Panama",
          "alternateName": "Residencia Panama",
          "url": "https://residenciapanama.com",
          "logo": "https://residenciapanama.com/logo.png",
          "description": "Studio di consulenza specializzato in servizi di residenza, cittadinanza e investimenti a Panama. Esperti in diritto internazionale, fiscalità e costituzione società offshore.",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Avenida 10 Norte  Calle Tael Casa C1 Urbanizacion Los Angeles Panama City",
            "addressLocality": "Panama City",
            "addressRegion": "Panama",
            "postalCode": "0801",
            "addressCountry": "PA"
          },
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+507-6958-4333",
            "contactType": "customer service",
            "availableLanguage": ["Italian", "Spanish", "English"]
          },
          "sameAs": [
            "https://rsinternationalservices.com/",
            "https://www.linkedin.com/company/rs-international-services"
          ],
          "foundingDate": "2015",
          "numberOfEmployees": "10-50",
          "areaServed": {
            "@type": "Country",
            "name": "Panama"
          },
          "serviceType": [
            "Residenza Panama",
            "Cittadinanza Panama", 
            "Investimenti Immobiliari",
            "Costituzione Società",
            "Consulenza Fiscale",
            "Servizi Bancari"
          ]
        };

      case 'localBusiness':
        return {
          "@context": "https://schema.org",
          "@type": "LegalService",
          "name": "RS International Services - Residencia Panama",
          "image": "https://residenciapanama.com/office-panama.jpg",
          "description": "Studio legale specializzato in residenza, cittadinanza e investimenti a Panama. Servizi professionali per privati e aziende.",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Avenida 10 Norte  Calle Tael Casa C1 Urbanizacion Los Angeles Panama City",
            "addressLocality": "Panama City",
            "addressRegion": "Panama",
            "postalCode": "0801",
            "addressCountry": "PA"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "8.9824",
            "longitude": "-79.5199"
          },
          "telephone": "+507-6958-4333",
          "email": "info@residenciapanama.com",
          "url": "https://residenciapanama.com",
          "openingHours": "Mo-Fr 09:00-18:00",
          "priceRange": "$$",
          "currenciesAccepted": "USD, EUR",
          "paymentAccepted": "Cash, Credit Card, Bank Transfer",
          "areaServed": {
            "@type": "Country",
            "name": "Panama"
          }
        };

      case 'article':
        return {
          "@context": "https://schema.org",
          "@type": "Article",
          "headline": data?.title || "Dazi USA sui Prodotti Italiani: Analisi Completa",
          "description": data?.excerpt || "Analisi approfondita dei dazi americani sui prodotti italiani",
          "image": data?.image || "/articolo_dazi.png",
          "author": {
            "@type": "Organization",
            "name": "RS International Services"
          },
          "publisher": {
            "@type": "Organization",
            "name": "RS International Services",
            "logo": {
              "@type": "ImageObject",
              "url": "https://residenciapanama.com/logo.png"
            }
          },
          "datePublished": data?.datePublished || "2025-01-15",
          "dateModified": data?.dateModified || "2025-01-15",
          "mainEntityOfPage": {
            "@type": "WebPage",
            "@id": `https://residenciapanama.com/blog/${data?.slug || 'dazi-usa-prodotti-italiani-2025'}`
          },
          "articleSection": data?.category || "Commercio Internazionale",
          "keywords": data?.keywords || "dazi usa, export italia, commercio internazionale",
          "wordCount": data?.wordCount || 2500,
          "timeRequired": `PT${data?.readTime || 18}M`,
          "inLanguage": "it-IT"
        };

      default:
        return {};
    }
  };

  const schemaData = getSchemaData();

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
    />
  );
};

export default SchemaMarkup;